package gr.tech.GRAttestation.navigation

sealed class AdminSitePage(val route: String) {
    data object Home: SitePage(route = "/admin/")
    data object Login: SitePage(route = "/admin/login")

    data object Stores: SitePage(route = "/admin/stores/") {
        fun passStoreId(id: String) = "/admin/stores/$id"
    }

    data object StoreUsers: SitePage(route = "/admin/users/") {
        fun passUserId(id: String) = "/admin/users/$id"
    }

    data object Receipts: SitePage(route = "/admin/stores/receipts") {
        fun passStoreId(storeId: String) = "/admin/stores/$storeId/receipts"
    }

    data object SKUs: SitePage(route = "/admin/models/")

    data object Users: SitePage(route = "/admin/users/") {
        fun passStoreId(uuid: String) = "/admin/users/$uuid"
    }

    data object Activity: SitePage(route = "/admin/activity/") {
        fun passProjectIdWithParams(uuid: String, edit: Boolean = false) = if (edit) "/admin/projects/$uuid?edit=$edit" else "/admin/projects/$uuid"
    }

    data object Projects: SitePage(route = "/admin/projects/") {
        fun passProjectIdWithParams(uuid: String, edit: Boolean = false) = if (edit) "/admin/projects/$uuid?edit=$edit" else "/admin/projects/$uuid"
    }
}